<template>
  <div>
    <div class="bg-white rounded">
      <div class="additional-container">
        <div class="py-3 px-1 pl-c-xl">
          <icon-view
            class="ml-3"
            :has-border="false"
            icon="fas fa-clock m-2"
            icon-background="transparent"
            icon-color="#FF7058"
            icon-size="1.0625rem"
            title="Historial de Presupuesto"
          />
        </div>
      </div>
      <div v-if="!!result.length">
        <time-line class="mt-4 px-4">
          <time-line-item
            v-for="(item, index) in result"
            :key="index"
            :icon="getBudgetAmountIcon(item.amount)"
          >
            <template #date>
              <label class="history-date-title">
                {{
                  $formatDate(
                    item.dateOfAction,
                    $templateDate.numberMonthDayYear
                  )
                }}
              </label>
              <label class="history-date-value">
                {{ $formatDate(item.dateOfAction, $templateDate.hour) }}
              </label>
            </template>
            <div id="main-info" class="row">
              <div class="col-md-2 item-col">
                <strong
                  v-if="isIncrementOperation(item.amount)"
                  class="align-label-budget"
                >
                  Aumento de Presupuesto
                </strong>
                <strong v-else class="align-label-budget">
                  Reducción de Presupuesto
                </strong>
              </div>
              <div class="col-md-1">
                <div class="vl" />
              </div>
              <div class="col-md-3 item-col">
                <label class="info-field-title">Cantidad:</label>
                <label
                  class="info-field-quantity"
                  :class="
                    isIncrementOperation(item.amount) ? '' : 'negative-amount'
                  "
                >
                  <div>{{ item.amount | signedAmount | numberWithCommas }}</div>
                </label>
              </div>
              <div class="col-3 item-col">
                <label class="info-field-title">Ajustado por:</label>
                <label class="info-field-asignator">
                  {{ item.createdByUser | empty }}
                </label>
              </div>
              <div class="col-3 item-col">
                <label class="info-field-title">Nuevo Total Disponible:</label>
                <label class="field-total-aviable">
                  {{ totalBudgetAvailable | price }}
                </label>
              </div>
            </div>
          </time-line-item>
        </time-line>
        <div class="actions-container container-fluid">
          <action-button
            v-if="showFetchMore"
            class="m-4 pl-5 pr-5 mx-auto outline rounded-pill"
            i="fas fa-angle-down"
            text="Ver más"
            variant="outline-success"
            @click="fetchMoreBudgetHistory"
          />
        </div>
      </div>
      <div v-else class="pb-5">
        <custom-result-not-found
          text="No cuenta con presupuesto ajustado en sistema."
        />
      </div>
    </div>
  </div>
</template>
<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
export default {
  name: 'BudgetHistory',
  components: {
    IconView,
    ActionButton,
    CustomResultNotFound,
    TimeLine,
    TimeLineItem,
  },
  filters: {
    empty: (value) => (value ? value : '-'),
    signedAmount: (value) => {
      if (value < 0) return '- ' + -value;
      return '+ ' + value;
    },
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    availableBudget: {
      type: Number,
      default: () => 0,
    },
    fetchMoreBudgetHistory: {
      type: Function,
      default: () => [],
    },
    showFetchMore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    result() {
      return this.value;
    },
    totalBudgetAvailable() {
      return this.availableBudget;
    },
  },
  methods: {
    isIncrementOperation(amount) {
      return amount >= 0;
    },
    getBudgetAmountIcon(amount) {
      return this.isIncrementOperation(amount)
        ? 'fas fa-arrow-circle-up m-2 bg-success'
        : 'fas fa-arrow-circle-down m-2 bg-danger';
    },
  },
};
</script>
<style scoped lang="scss">
$colorGray: #727272;
$colorDarkGray: #11291b;
$colorWhiteSmoke: #eeeeee;
$colorMoneyRed: #c9545e;
$colorMoneyGreen: #2db782;

.radius {
  background-color: $colorMoneyGreen;
}
#main-info {
  margin: 0rem 0.625rem;
  border-radius: 0.25rem;
  strong {
    text-align: left;
    font-family: Lato;
    font-size: 1rem;
    font-weight: bold;
    letter-spacing: 0px;
    color: $colorDarkGray;
    display: block;
  }
}
.info-field-asignator {
  text-align: left;

  letter-spacing: 0px;
  color: $colorDarkGray;
  display: block;
}
.info-field-quantity {
  text-align: left;
  font-weight: bold;
  letter-spacing: 0px;
  color: $colorMoneyGreen;
  display: block;
}
.negative-amount {
  color: $colorMoneyRed;
}
.field-total-aviable {
  text-align: left;
  font-weight: bold;
  letter-spacing: 0px;
  color: $colorMoneyGreen;
  display: block;
}
.bubble-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.7rem;
  border-radius: 3.125rem;
}
.info-field-value {
  text-align: left;
  font: normal normal normal 1rem/1.75rem Lato;
  letter-spacing: 0px;
  color: $colorDarkGray;
  display: block;
}
.info-field-title {
  text-align: left;
  font: normal normal normal 0.875rem/1.75rem Lato;
  letter-spacing: 0px;
  margin: 0;
  color: $colorGray;
}
.history-date-title {
  text-align: left;
  margin-bottom: 0px;
  font: Bold 1rem/1.3125rem Lato;
  letter-spacing: 0px;
  color: $colorDarkGray;
}

.history-date-value {
  font: normal normal normal 0.75rem/1.3125rem Lato;
  text-align: left;
  letter-spacing: 0px;
  color: $colorDarkGray;
}
.item-col {
  display: block;
}
.actions-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.align-label-budget {
  position: relative;
  top: 14px;
}
.vl {
  border-left: 1px solid #e2e2e2;
  height: 50px;
}
::v-deep .dot {
  box-shadow: none !important;
}
</style>
